import React, { useMemo } from 'react'
import {
  StyledVariable,
  UrgencyHandler,
  URGENCY_TEXTS_VARIABLE_NAME,
  type UrgencyEntries,
  type UrgencyVariableKey,
} from '@mc/feature-variables'
import { useTranslation } from '@mc/i18n'
import { BOGO_I18N_NAMESPACE } from '../../../i18n'

export type UrgencyCopyProps = {
  fullStop?: boolean
  textKey: UrgencyVariableKey
}

export const UrgencyCopy = ({
  textKey,
  fullStop = false,
}: UrgencyCopyProps) => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)
  const urgencyConfig = useMemo(
    () => ({
      urgencyMessage: {
        variableName: URGENCY_TEXTS_VARIABLE_NAME,
        variableKey: textKey,
      },
    }),
    [textKey],
  ) as UrgencyEntries

  return (
    <UrgencyHandler config={urgencyConfig} trackEV={true}>
      {({ urgencyMessage }) => (
        <>
          <StyledVariable
            text={urgencyMessage}
            defaultCopy={t('urgency.title')}
          />
          {fullStop && '.'}
        </>
      )}
    </UrgencyHandler>
  )
}
